import { render, staticRenderFns } from "./SeedTypes.vue?vue&type=template&id=2a499b14"
import script from "./SeedTypes.vue?vue&type=script&lang=js"
export * from "./SeedTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports